export type DonationEventType =
  | 'payment_completed'
  | 'payment_refunded'
  | 'gift_changed'
  | 'created'
  | 'amount_changed'
  | 'payment_method_changed'
  | 'canceled'
  | 'matched'
  | 'payment_declined'
  | 'suspended'
  | 'reactivated'
  | 'subscription_started'
  | 'subscription_canceled'

export interface DonationEventGiftImage {
  id: number
  cdn_url: string | null
  title: string | null
  caption: string | null
}

export interface DonationEvent {
  id: number
  event_type: DonationEventType
  occurred_at: string
  status: string | null
  amount: number | null
  monthly: boolean | null
  account_type: string | null
  delivery_method: string | null
  card_brand: string | null
  card_last4: string | null
  gift_name: string | null
  gift_image: DonationEventGiftImage | null
  donation: { receipt_id: string; monthly: boolean } | null
  detail: { type: 'receipt' | 'confirmation' | 'none'; receipt_id: string | null }
}

export interface MemberActivityResponse {
  data: DonationEvent[]
  total: number
}

const toNumberOrNull = (value: unknown): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value)
    return Number.isFinite(n) ? n : null
  }
  return null
}

export function mapResponseToActivity(raw: unknown): DonationEvent {
  const r = (raw ?? {}) as Record<string, unknown>
  const rawDetail = (r.detail ?? {}) as Record<string, unknown>
  return {
    ...(r as object),
    id: Number(r.id),
    amount: toNumberOrNull(r.amount),
    detail: {
      type: (rawDetail.type as 'receipt' | 'confirmation' | 'none') ?? 'none',
      receipt_id: (rawDetail.receipt_id as string | null) ?? null,
    },
  } as DonationEvent
}
